import React, { useState, useEffect, useCallback } from 'react';
import { callApi } from './api';

function AccessRequestsDashboard({ ownerId, onClose }) {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRequests = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await callApi('listAccessRequestsForOwnerV2', { ownerId });
      setRequests(result.requests);
    } catch (err) {
      setError('Kunne ikke hente tilgangsforespørsler: ' + err.message);
    } finally {
      setLoading(false);
    }
  }, [ownerId]);

  useEffect(() => {
    fetchRequests();
  }, [fetchRequests]);

  const handleApprove = async (requestId) => {
    if (window.confirm('Er du sikker på at du vil godkjenne denne forespørselen?')) {
      try {
        await callApi('approveAccessRequestV2', { requestId });
        fetchRequests(); // Refresh the list
      } catch (err) {
        setError('Kunne ikke godkjenne forespørsel: ' + err.message);
      }
    }
  };

  const handleDeny = async (requestId) => {
    if (window.confirm('Er du sikker på at du vil avslå denne forespørselen?')) {
      try {
        await callApi('denyAccessRequestV2', { requestId });
        fetchRequests(); // Refresh the list
      } catch (err) {
        setError('Kunne ikke avslå forespørsel: ' + err.message);
      }
    }
  };

  if (loading) return <p>Laster tilgangsforespørsler...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div>
      <h3>Ventende Tilgangsforespørsler</h3>
      {requests.length === 0 ? (
        <p>Ingen ventende tilgangsforespørsler.</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Bruker</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>E-post</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Portnavn</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Forespørsel sendt</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', width: '1%', whiteSpace: 'nowrap' }}>Handlinger</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <tr key={request.id}>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{request.requestingUserDisplayName}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{request.requestingUserEmail}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{request.gateName}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  {(() => {
                    const ts = request.createdAt || request.timestamp;
                    return ts && ts._seconds 
                      ? new Date(ts._seconds * 1000).toLocaleString() 
                      : 'Ukjent dato';
                  })()}
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px', width: '1%', whiteSpace: 'nowrap' }}>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button onClick={() => handleApprove(request.id)}>Godkjenn</button>
                    <button onClick={() => handleDeny(request.id)} style={{ backgroundColor: 'var(--danger-color)' }}>Avslå</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AccessRequestsDashboard;